export var HEADER_NAVIGATION_ITEM_CLASS_PREFIX = 'HeaderNavigationItem';
export var headerNavigationItemRoot = 'HeaderNavigationItemRoot';